import { Mesh } from 'three';

import { MeshProps, useFrame } from '@react-three/fiber';
import * as React from 'react';

export type Props = MeshProps;

function Box(props: Props) {
  const [clicked, setClicked] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);
  const ref = React.useRef<Mesh>(null);
  useFrame((_, delta) => {
    const elMesh = ref.current!;
    elMesh.rotation.z += delta;
  });
  return (
    <mesh
      ref={ref}
      onClick={() => setClicked(!clicked)}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      scale={clicked ? 1.5 : 1}
      {...props}
    >
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color={hovered ? 'hotpink' : 'orange'} />
    </mesh>
  );
}

export default React.memo(Box);
